var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-overlay"}),_c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"loader-item"},_vm._l((8),function(n){return _c('div',{key:n})}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }